import React, { forwardRef } from "react";
import Work from "../Components/Work";
import { personalDetails, workDetails, eduDetails, calculateTotalExperience } from "../Details";

export const About = forwardRef((props, ref) => {
  return (
    <main ref={ref} id="about" className="container mx-auto max-width pt-[6vw] pb-20 ">
      <section>
        <h1 className="text-2xl text-center text-dark-heading dark:text-light-heading md:text-4xl xl:text-4xl xl:leading-tight font-bold">
          About Me
        </h1>
        <div className="flex flex-col lg:flex-row items-center justify-center lg:gap-[5vw] my-[2vw]">
          <img src="https://camo.githubusercontent.com/660e8839e806a7a23f61b155be2e078a1cbd67f33c65b38994f8318cbd9e50f6/68747470733a2f2f6d656469612e67697068792e636f6d2f6d656469612f7167515567674143335066763638377150432f67697068792e676966" className="w-full lg:w-[50%] xl:w-[40%] 2xl:w-[30%] h-[50vh] lg:h-auto" alt="hard man" />
          <div className="lg:w-[50%] xl:w-[60%] 2xl:w-[70%]">
            {personalDetails.about.map((el, idx) => <p key={idx} className="text-content py-4">{el}</p>)}
          </div>
        </div>
      </section>
      <section>
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-4xl xl:leading-tight font-bold pt-10">Work Experience <span className="text-lg md:text-2xl text-content">({calculateTotalExperience()})</span></h1>
        {React.Children.toArray(
          workDetails.map(({ Position, Company, Location, Type, Duration }) => (
            <Work key={Position} position={Position} company={Company} location={Location} type={Type} duration={Duration} />
          ))
        )}
      </section>
      <section>
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-4xl xl:leading-tight font-bold pt-10">
          Education
        </h1>
        {React.Children.toArray(
          eduDetails.map(({ Position, Company, Location, Type, Duration }) => (
            <Work key={Position} position={Position} company={Company} location={Location} type={Type} duration={Duration} />
          ))
        )}
      </section>
    </main>
  );
})
